import { render, staticRenderFns } from "./SalesPerformance.vue?vue&type=template&id=4ec573ac&scoped=true"
import script from "./SalesPerformance.vue?vue&type=script&lang=js"
export * from "./SalesPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec573ac",
  null
  
)

export default component.exports